import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Inline playful loader for the EPC trace on the raise-export-request page.
 *
 * <p>Unlike {@link GlobeLoader} this is deliberately <strong>not</strong> a blocking overlay:
 * tracing is a plain read (`GET /api/traces`) that usually returns in well under a second, so it
 * renders in the slot the results will land in and gives the page somewhere to be while it waits.
 *
 * <p>The motion is a treadmill, not a journey across the viewBox: the parcel bounces in place at
 * the centre while the checkpoint track scrolls beneath it. The scroll distance per cycle is
 * exactly one checkpoint gap, so the loop is seamless at any trace duration, and a checkpoint is
 * always directly under the parcel at the instant it lands. Checkpoints are drawn twice — once dim,
 * once lit, clipped either side of the centre line — so each one appears to light up as the parcel
 * stamps it, with no per-checkpoint timing to keep in sync.
 */
@Component({
  selector: 'app-trace-loader',
  imports: [CommonModule],
  templateUrl: './trace-loader.html',
  styleUrl: './trace-loader.scss',
})
export class TraceLoader {
  /** Shown in a monospace chip under the caption so the user can confirm what is being traced. */
  @Input() epc = '';

  @Input() label = 'Tracing the EPC';

  @Input() caption = 'Walking the chain of custody, checkpoint by checkpoint…';
}
